// namespace
export const TAOLA= 'taola'

// mutations
export const SET_RESERVATION_INFO = 'SET_RESERVATION_INFO'